import { observer } from 'mobx-react'
import { useContext } from 'react'
import { Header } from '@/components/Generic'
import { StoreContext } from '@store/Root.store'
import { Illustration } from '@/components/Illustration/Illustration'
import { AmexGreatLayout } from './AmexGreatLayout'

export const ReadIdCompletedAmexGreatPage = observer(() => {
  const store = useContext(StoreContext)
  const { readIdPage: trans } = store.TranslationsState.translations

  return (
    <AmexGreatLayout>
      <div className="page-container mobile-m-0 vertically-centered">
        <Illustration type="device-not-switched" />
        <Header className="m-0-0-30">{trans?.allSet}</Header>
        <div className="generic__paragraph-centered">
          {trans?.readIdCompleted}
          <br />
          {trans?.continueOnDesktop}
        </div>
      </div>
    </AmexGreatLayout>
  )
})
